const loading = {
  state: () => ({
    isLoading: true,
    isLoadingProgress: true,
    isExtensionClipUploadFinish: true,
  }),
  mutations: {
    // 로딩 화면 설정
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading
    },
    setIsLoadingProgress(state, isLoadingProgress) {
      state.isLoadingProgress = isLoadingProgress
    },
    setIsExtensionClipUploadFinish(state, isExtensionClipUploadFinish) {
      // console.log('isExtensionClipUploadFinish', isExtensionClipUploadFinish)
      state.isExtensionClipUploadFinish = isExtensionClipUploadFinish
    },
  },
  actions: {
    // 로딩 화면 설정
    async setIsLoading({ commit }, isLoading) {
      commit('setIsLoading', isLoading)
    },
    async setIsLoadingProgress({ commit }, isLoadingProgress) {
      commit('setIsLoadingProgress', isLoadingProgress)
    },
    async setIsExtensionClipUploadFinish({ commit }, isExtensionClipUploadFinish) {
      // console.log('isExtensionClipUploadFinish actions', isExtensionClipUploadFinish)

      commit('setIsExtensionClipUploadFinish', isExtensionClipUploadFinish)
    },
  },
  getters: {
    chk_isLoading(state) {
      return state.isLoading
    },
    chk_isLoadingProgress(state) {
      return state.isLoadingProgress
    },
    isExtensionClipUploadFinish(state) {
      return state.isExtensionClipUploadFinish
    },
  },
}

export default loading
